module.exports = __webpack_public_path__ + "img/cross.846e844d.svg";